module.exports = __webpack_public_path__ + "img/icon20250509001.e6c0bb59.png";